import script from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=1e309440&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e309440"]])

export default __exports__